import React from "react";
import Chart from "react-apexcharts";

const VERIFICATION_STATUS_CONFIG = {
  VERIFIED: "#22C55E",
  PAYMENT_VERIFICATION_PENDING: "#F59E0B",
  SCAN_VERIFICATION_PENDING: "#60A5FA",
  Pending: "#F87171",
};

const VerificationStatusBreakdownChart = ({ rows }) => {
  const safeRows = Array.isArray(rows) ? rows : [];

  if (safeRows.length === 0) {
    return (
      <div className="h-80 flex items-center justify-center text-gray-400">
        No status data available
      </div>
    );
  }

  const categories = safeRows.map((r) => r.label || "");

  const statuses = Object.keys(VERIFICATION_STATUS_CONFIG).filter((status) =>
    safeRows.some((r) => (r.verificationStatuses || {})[status] > 0)
  );

  // 🚨 Critical Guard
  if (statuses.length === 0) {
    return (
      <div className="h-80 flex items-center justify-center text-gray-400">
        No verification status data
      </div>
    );
  }

  const series = statuses.map((status) => ({
    name: status,
    data: safeRows.map(
      (r) => (r.verificationStatuses || {})[status] || 0
    ),
  }));

  const options = {
    chart: {
      stacked: true,
      id: "verification-status-breakdown",
      toolbar: { show: false },
    },
    xaxis: {
      categories,
      labels: { style: { colors: "#FFFFFF" } },
    },
    yaxis: {
      labels: { style: { colors: "#FFFFFF" } },
    },
    colors: statuses.map((s) => VERIFICATION_STATUS_CONFIG[s]),
    legend: {
      position: "bottom",
      labels: { colors: "#FFFFFF" },
    },
    tooltip: {
      y: {
        formatter: (val) => val?.toString?.() || "0",
      },
    },
  };

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={400}
    />
  );
};

export default VerificationStatusBreakdownChart;